import FranciscoGiancarelli from "./FranciscoGiancarelli";
import JuanBecchio from "./JuanBecchio/";
import LuisFernandoRamos from "./LuisFernandoRamos";
import JosueVitali from "./JosueVitali";
import FedericoSn from "./FedericoSn/";
import JustoMedina from "./JustoMedina/JustoMedina";
import LautaroGS from "./LautaroGS/LautaroGS";
import SebaPegoraro from "./SebastianPegoraro";
import VictorBracco from "./VictorBracco";
import FacundoMidvetkin from "./FacundoMidvetkin";
import ValentinGalfre from "./ValentinGalfre";
import AgustinGuerra from "./AgustinGuerra";
import LuiSanchez from "./LuiSanchez";
import EstebanCaccin from "./EstebanCaccin/EstebanCaccin";
import IgnacioMustafha from "./IgnacioMustafha/IgnacioMustafha";

const Developers = [
  JuanBecchio,
  JosueVitali,
  FranciscoGiancarelli,
  LuisFernandoRamos,
  LuiSanchez,
  FedericoSn,
  JustoMedina,
  LautaroGS,
  SebaPegoraro,
  VictorBracco,
  FacundoMidvetkin,
  ValentinGalfre,
  AgustinGuerra,
  EstebanCaccin,
  IgnacioMustafha
];

export default Developers;
